<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class Authentication extends Vue {
        name = 'authentication';

        created() {
            if (this.$auth.isAuthenticated()) {
                let redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'evaluation-students'
                    });
                }
            }
        }
    }

    Vue.component('authentication', Authentication);
</script>



// WEBPACK FOOTER //
// src/components/auth/Authentication.vue